import { render } from "./Catalog.vue?vue&type=template&id=e91362ac&scoped=true&ts=true&lang=pug"
import script from "./Catalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=ts"

import "./Catalog.vue?vue&type=style&index=0&id=e91362ac&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91362ac"]])

export default __exports__